import { useState } from "react";
import { RxReset } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button";
import Card from "../../../components/Card";
import { useToaster } from "../../../components/toaster";
import { RokaApiError } from "../../../errors/RokaApiError";
import { useAdminApi } from "../../../hooks/api-hooks/useAdminApi";

const NewUser = () => {
  const navigate = useNavigate();
  const { createUser } = useAdminApi();
  const { showToaster } = useToaster();

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    isAdmin: false,
    site: "",
  });

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? (e.target as HTMLInputElement).checked
          : name === "isAdmin"
            ? value === "admin"
            : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    createUser(formData)
      .then(() => {
        showToaster(`Bruker "${formData.username}" ble opprettet!`, {
          type: "success",
        });
        navigate("/admin");
      })
      .catch((error) => {
        if (error instanceof RokaApiError) {
          showToaster(`Kunne ikke opprette bruker: ${error.message}`, {
            type: "error",
            errorId: error.requestId,
          });
        } else {
          showToaster("En uventet feil oppstod under opprettelse av bruker", {
            type: "error",
          });
          console.error("Error creating user:", error);
        }
      });
  };

  const handleBack = () => {
    navigate(-1); // Navigate back to the previous page
  };

  return (
    <div className="new-user-view">
      <h1>Opprett ny bruker</h1>

      <Card>
        <div className="wrapper">
          <form onSubmit={handleSubmit} className="new-user-form">
            <div className="form-group">
              <label htmlFor="username">Brukernavn</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Passord</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="site">Site</label>
              <input
                type="text"
                id="site"
                name="site"
                value={formData.site}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="role">Rolle</label>
              <select
                id="role"
                name="isAdmin"
                value={formData.isAdmin ? "admin" : "user"}
                onChange={handleInputChange}
                required
              >
                <option value="user">Bruker</option>
                <option value="admin">Admin</option>
              </select>
            </div>

            <div className="actions">
              <Button
                className="back-button"
                intent="primary"
                buttonStyle="outline"
                background="card"
                onClick={handleBack}
              >
                <RxReset />
              </Button>
              <Button
                className="save-button"
                intent="success"
                buttonStyle="flat"
                background="card"
              >
                Opprett bruker
              </Button>
            </div>
          </form>
        </div>
      </Card>
    </div>
  );
};

export default NewUser;
